import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ThemeProvider } from "@/components/ThemeProvider";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Fibaro from "@/pages/Fibaro";
import Solutions from "@/pages/Solutions";
import Dealers from "@/pages/Dealers";
import Interior from "@/pages/Interior";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/fibaro" element={<Fibaro />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/dealers" element={<Dealers />} />
              <Route path="/interior" element={<Interior />} />
              <Route path="/support" element={<Support />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
